import { Component, Event, EventEmitter, h, Method, Prop, State } from "@stencil/core";
import { Column } from "../table-interfaces";
import { TableCell } from "../table-cell/table-cell";
import { TableHeader } from "../table-header/table-header";
import { SortDirection } from "../table-types";
import { Table } from "../table";

@Component({
    tag: "uic-table-column-checkbox",
    styleUrl: "table-column-checkbox.scss",
    shadow: false
})
export class TableColumnCheckbox implements Column {
    /** defines which field of the table will be displayed in the column */
    @Prop() readonly field: string;
    /** defines the label of the table column */
    @Prop() readonly label: string;
    /** defines if the column should be a group */
    @Prop() readonly group: boolean = false;
    /** defines if the column should be sortable */
    @Prop() readonly sortable: boolean = false;
    /** defines if the checkbox should be editable */
    @Prop() readonly editable: boolean = false;

    @State() initialSortDirection: SortDirection = "";

    /** make the render function public */
    @Method()
    async getColumnMethods() {
        return {
            renderCell: this.renderCell.bind(this),
            renderHeader: this.renderHeader.bind(this),
            getSortString: this.getSortString.bind(this)
        };
    }

    /**
     * triggered when a checkbox was changed
     */
    @Event({
        eventName: "uicCheckboxChange",
        composed: true,
        cancelable: true,
        bubbles: true
    })
    checkboxAction: EventEmitter;

    private onCheckboxEvent = (row: object) => (event: Event) => {
        const checked = (event.target as HTMLUicCheckboxElement).checked;
        this.checkboxAction.emit({
            checked,
            row,
            field: this.field
        });
    };

    // eslint-disable-next-line
    private getSortString(row: any) {
        const { field } = this;
        return field === "" ? "" : row[field] ? "1" : "0";
    }

    private renderHeader({ initialSortingCriterion: sortCriterion }: Table) {
        const sortData = sortCriterion?.sortProperty === this.field ? sortCriterion : undefined;
        return (
            <TableHeader
                label={this.label}
                sortable={this.sortable}
                sortField={this.field}
                group={this.group}
                testId={this.field}
                initialSortDirection={sortData?.direction ?? ""}
            />
        );
    }
    // eslint-disable-next-line
    private renderCell(row: any) {
        const { field, group, editable } = this;
        const empty = field === "";
        return (
            <TableCell group={group} testId={field}>
                {!empty && (
                    <uic-checkbox onUicChange={this.onCheckboxEvent(row)} disabled={!editable} checked={row[field]}></uic-checkbox>
                )}
            </TableCell>
        );
    }
}
